/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { sizes, Spacer, colors } from '@smartsheet/lodestar-core';
import { MAX_RECORDS } from '../../../../../../services/ducks/workflowDuck/workflowDuck';
import { getVerticalSpacingAroundRunLogList } from '../../../../../../utils/dimensions';
import { Column } from '../../../../../common/Column';

const shine = `
  @keyframes shine: {
    0%: {
      background-position: -100px;
    },
    40%, 100%: {
      background-position: 140px;
    }
  }
`;
const shineColour = 'rgba(229,229,229,0.8)';
const backgroundGradient = {
  backgroundImage: `linear-gradient(90deg, ${colors.neutralLight20} 0px, ${shineColour} 40px, ${colors.neutralLight20} 80px)`,
  backgroundSize: '600px',
};

const animationDuration = '2.0s';

const baseStyle = `
    height: 12px;
    border-radius: ${sizes.xSmall}px;
    background-color: ${colors.neutralLight40};
    background-image: ${backgroundGradient.backgroundImage};
    background-size: ${backgroundGradient.backgroundSize};
    animation: ${shine} ${animationDuration} infinite ease-out;
    box-sizing: border-box;
`;
const statusWrapper = css`
  display: flex;
  height: 24px;
  padding: 8px 16px;
  align-items: center;
`;
const statusIcon = css`
  ${baseStyle};
  width: 16px;
`;
const statusLabel = css`
  ${baseStyle};
  width: calc(100% - 16px);
`;
const timestamp = css`
  ${baseStyle};
  width: 100%;
`;

export const ListLoadingState = () => {
  const placeholders = [];
  for (let i = 0; i < MAX_RECORDS; i++) {
    placeholders.push(
      <Spacer orientation="row" space="small" key={i} css={statusWrapper}>
        <Column width="70%">
          <div css={statusIcon} />
          <div css={statusLabel} />
        </Column>
        <Column
          css={css`
            justify-content: flex-end;
          `}
          width="30%"
        >
          <div css={timestamp} />
        </Column>
      </Spacer>
    );
  }

  return (
    <div
      data-pa11y-id="pa11y-runlog-body"
      css={css`
        margin-top: ${sizes.medium}px;
        height: calc(100vh - ${getVerticalSpacingAroundRunLogList()}px);
      `}
    >
      {placeholders}
    </div>
  );
};
